import {useState} from 'react'
import DpiForm from './DpiForm';
import DpiListview from './DpiListview';

const DPI = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <DpiForm addForm={setFromIsShown} update={upData}  sId={serviceId} />
        ) : (
          <DpiListview addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
        )}
      </>
  )
}

export default DPI